import type {AddressPin, UserAddressPin} from '../model/types'

export function isUserAddressPin(addressPin?: AddressPin): addressPin is UserAddressPin {
  return Boolean(addressPin && addressPin.__type === 'user-address-pin')
}
